import { Component, h, Host, State, Listen, Env } from '@stencil/core';
import 'aiba-component-library';
import { analyticsService, binService, pdfService, profileService, recommendationService, feedbackService, videoService } from 'aiba-ui-services';
import { getScreenData } from '../../data';
import * as utils from '../../../../../common/hair-quiz-vto/utils/utils';
import * as stateutilsClosure from '../../../../../common/hair-quiz-vto/utils/state.utils';
import * as config from '../../root/config';
import { getState } from '../../utils/store';
import translationValues from '../../i18n/locales/target.json';

import * as breadCrumbStepHandlers from '../../../../../common/hair-quiz-vto/handlers/breadcrumb.handler';
import { fetchTranslations } from '../../../../../common/hair-quiz-vto/utils/translations.utils';
import * as welcomeScreenHandlers from '../../../../../common/hair-quiz-vto/handlers/welcome.handlers';
import * as welcomeScreenLocaleHandlers from '../../handlers/welcome.handlers';
import * as quizScreenHandlers from '../../handlers/quiz.handlers';
import * as vtoScreenHandlers from '../../global/handlers/vtoScreen.handlers';
import * as resultScreenHandlers from '../../../../../common/hair-quiz-vto/handlers/result.handlers';
import * as resultScreenLocaleHandlers from '../../handlers/result.handlers';
import * as selfieAnalysisFailedHandlers from '../../../../../common/hair-quiz-vto/handlers/selfieAnalysisFailedHandlers';
import { isMobile, scrollToTop } from '../../../../../common/hair-quiz-vto/utils/utils';
const REDIRECT_URL = Env.REDIRECT_URL_EN_US;
const TY_DOMAINS = Env.TY_DOMAINS;
@Component({
  tag: 'aiba-app',
  styleUrl: '../../global/global.scss',
  shadow: true,
})
export class AibaApp {
  @State() breadCrumbData: [];
  @State() state: any = {};
  @State() loading: boolean = false;
  @State() desktopview: boolean = false;
  @State() landScapeView: boolean = false;
  @State() setSticky: boolean = false;

  async connectedCallback() {
    try {
      console.info('@AIBA[app.connectedCallback.fetchTranslations]: DONE', 1);
    } catch (error) {
      console.error('@AIBA[app.connectedCallback.fetchTranslations.error]: ', error);
    }
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    if (!isMobile()) {
      this.desktopview = true;
    } else {
      this.desktopview = false;
    }
  }
  async updateOriginatingSource() {
    let configObj = { ...config };
    if (configObj.default.profileStore.formV3.header.originatingSource) {
      configObj.default.profileStore.formV3.header.originatingSource = 'TY chatbot - Virtual Try On';
    }
    return configObj;
  }
  isTySite() {
    let tySite = false;
    if (TY_DOMAINS) {
      const LIST_TY_DOMAINS = TY_DOMAINS.split(',');
      const currentDomain = this.getDomainName();
      const domainExists = LIST_TY_DOMAINS.some(domain => domain.toLowerCase() === currentDomain);
      if (domainExists) {
        tySite = true;
      }
    }
    return tySite;
  }
  async componentWillLoad() {
    scrollToTop();
    if (!isMobile()) {
      this.desktopview = true;
    }
    if (this.isLandscape()) {
      this.landScapeView = true;
    }
    this.state = await getState();
    const stateutils = stateutilsClosure.stateUtils(this.state);
    window['AIBA'] = { utils: { ...utils, ...stateutils, binService, pdfService, profileService, recommendationService, analyticsService, feedbackService, videoService } };
    const {
      default: {
        brand: { brand, locale, version, journey_type },
      },
    } = config;
    const I18N_WEB_STORAGE_KEY = `aiba.${brand}.${locale.toLowerCase()}.${journey_type}.${version}.i18n`;

    if (this.isTySite()) {
      const configData = await this.updateOriginatingSource();
      await stateutils.setConfig(configData);
    } else {
      await stateutils.setConfig(config);
    }

    await fetchTranslations(translationValues, I18N_WEB_STORAGE_KEY);
    this.state.keepPhoto = false;
  }
  async componentWillRender() {
    this.breadCrumbData = await breadCrumbStepHandlers.handleBreadCrumbOnLoad();
  }

  isLandscape() {
    return window.matchMedia('(orientation: landscape)').matches;
  }

  @Listen('resize', { target: 'window' })
  handleLandscapeView() {
    if (this.isLandscape()) {
      this.landScapeView = true;
    } else {
      this.landScapeView = false;
    }
  }

  onclick = event => {
    analyticsService.registerEvent('event2', event);
  };

  async componentDidRender() {
    scrollToTop();
    if (!document.getElementById('YMK-module')) {
      const div = document.createElement('div');
      div.id = 'YMK-module';
      document.getElementsByTagName('aiba-app')[0].parentElement.insertBefore(div, document.getElementsByTagName('aiba-app')[0]);
      document.getElementById('YMK-module').style.background = '#000';
      document.getElementById('YMK-module').style.display = 'none';
    }

    if (this.isTySite()) {
      document.querySelector('aiba-app').shadowRoot.querySelector('#link_hair_journey')['style'].display = 'none';
    } else {
      document.querySelector('aiba-app').shadowRoot.querySelector('#link_hair_journey')['style'].display = 'block';
    }
  }
  getDomainName = () => {
    // Get the full URL
    const fullUrl = window.location.href;

    // Create a new URL object
    const url = new URL(fullUrl);

    // Get the domain (host) without the protocol (http:// or https://)
    const domain = url.hostname;

    return domain.toLowerCase();
  };
  render() {
    if (this.desktopview) {
      window.open(REDIRECT_URL, '_self');
    }

    if (this.state.showResultScreen || this.state.hideVTO) {
      if (document.getElementById('YMK-module')) {
        document.getElementById('YMK-module').style.display = 'none';
        this.setSticky = false;
      }
    } else {
      if (document.getElementById('YMK-module')) {
        document.getElementById('YMK-module').style.display = 'block';
        this.setSticky = true;
      }
    }

    if (this.landScapeView) {
      if (document.getElementById('YMK-module')) {
        document.getElementById('YMK-module').style.display = 'none';
        this.setSticky = false;
      }
    }

    return (
      <Host style={{ position: this.setSticky ? 'sticky' : 'static', bottom: '2px', zIndex: '2' }}>
        <main class={`screen-wrapper ${this.state.currentJourney}`}>
          <div>
            {this.state.currentJourney === 'welcome_screen' && (
              <aiba-welcome-screen
                getData={() => getScreenData('aiba-welcome-screen')}
                handlers={{ ...welcomeScreenHandlers, ...welcomeScreenLocaleHandlers }}
              ></aiba-welcome-screen>
            )}
            {this.state.currentJourney === 'quiz_screen' && (
              <div>
                {this.state.currentJourney === 'quiz_screen' && (
                  <aiba-quiz-single-screen getData={() => getScreenData('aiba-quiz-screen')} handlers={quizScreenHandlers}></aiba-quiz-single-screen>
                )}
                <div class={!this.state.showResultScreen && !this.state.hideVTO ? 'show' : 'hide'}>
                  {!this.landScapeView ? (
                    <aiba-vto-screen handlers={vtoScreenHandlers} getData={() => getScreenData('aiba-vto-screen')} keepPhoto={this.state.keepPhoto}></aiba-vto-screen>
                  ) : (
                    <div id="landscapeErrorMsg">{'Turn phone upright'} </div>
                  )}
                </div>
              </div>
            )}
            {this.state.currentJourney === 'vto_screen' && (
              <div>
                <div class={!this.state.showResultScreen ? 'show' : 'hide'}>
                  {!this.landScapeView ? (
                    <aiba-vto-screen handlers={vtoScreenHandlers} getData={() => getScreenData('aiba-vto-screen')} keepPhoto={this.state.keepPhoto}></aiba-vto-screen>
                  ) : (
                    <div id="landscapeErrorMsg">{'Turn phone upright'} </div>
                  )}
                </div>
                {this.state.showResultScreen && (
                  <aiba-result-screen
                    getData={() => getScreenData('aiba-result-screen')}
                    handlers={{ ...resultScreenHandlers, ...resultScreenLocaleHandlers }}
                  ></aiba-result-screen>
                )}
              </div>
            )}
             {this.state.currentJourney === 'vto_screen' && this.state.showErrorScreen && (
              <aiba-selfie-analysis-failed-screen
              getData={() => getScreenData('aiba-selfie-analysis-failed-screen')}
              handlers={selfieAnalysisFailedHandlers}
            ></aiba-selfie-analysis-failed-screen>
            )}
          </div>
        </main>
      </Host>
    );
  }
}
